import { ContainerView } from './containerView.js';

class WorkSheetContainerView extends ContainerView {
	_generateContainerMarkup() {
		return `
        <div class="worksheet-container worksheet" dir="rtl">

             <div class="worksheet-title">تدريبات ورقية</div>
             <div class="worksheet-content"></div>

             <div class="relatedItems">
                 <p class="heading-3">تدريبات مشابهة</p>
                 <div class="relatedItems-content"></div>
            </div>

            <div class="pagination-content"></div>
        </div>`;
	}
}
export default new WorkSheetContainerView();
